import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TimezoneSelect from "react-timezone-select";
import { FaRegCalendarAlt, FaClock } from "react-icons/fa";

const DateTime = ({
  handleSaveEvent,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  startTime,
  setStartTime,
  endTime,
  setEndTime,
  timezone,
  setTimezone,
  errors = {},         
  setErrors,          
}) => {
  // Validate on change
const handleStartDateChange = (date) => {
  setStartDate(date);
  if (errors.startDate) {
    setErrors((prev) => ({ ...prev, startDate: "" }));
  }
};

const handleStartTimeChange = (time) => {
  setStartTime(time);
  if (errors.startTime) {
    setErrors((prev) => ({ ...prev, startTime: "" }));
  }
};

  // Validate and save
  const validateAndSave = () => {
    const newErrors = {};

    if (!startDate) newErrors.startDate = "Start date is required";
    if (!startTime) newErrors.startTime = "Start time is required";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    handleSaveEvent();
  };

  return (
    <div className="card shadow-sm">
      {/* <div className="card-header setting_card_heading setting_card_heading_size">
        <h5>Date & Time</h5>
        <p>
          Set the schedule for your event, including the start and end dates,
          times, and time zones.
        </p>
      </div> */}

      <div className="card-body settings_body_div border-0">
        <div className="row info_textbox_icon">
          {/* Time Zone */}
          <div className="col-md-12">
            <div className="mb-3">
              <label className="fw-bold">Time Zone</label>
              <TimezoneSelect value={timezone} onChange={setTimezone} />
            </div>
          </div>

          {/* Start Date */}
          <div className="col-md-3">
            <div className="mb-3">
              <label className="fw-bold">
                Start Date <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <DatePicker
                  selected={startDate}
                  onChange={handleStartDateChange}
                  dateFormat="dd MMM yyyy"
                  className={`form-control ${errors.startDate ? "is-invalid" : ""}`}
                  placeholderText="Select start date"
                />
                <span className="input-group-text">
                  <FaRegCalendarAlt />
                </span>
              </div>
              {errors.startDate && (
                <div className="text-danger mt-1">{errors.startDate}</div>
              )}
            </div>
          </div>

          {/* End Date */}
          <div className="col-md-3">
            <div className="mb-3">
              <label className="fw-bold">End Date</label>
              <div className="input-group">
                <DatePicker
                  selected={endDate}
                  onChange={setEndDate}
                  dateFormat="dd MMM yyyy"
                  className="form-control"
                  placeholderText="Select end date"
                />
                <span className="input-group-text">
                  <FaRegCalendarAlt />
                </span>
              </div>
            </div>
          </div>

          {/* Start Time */}
          <div className="col-md-3">
            <div className="mb-3">
              <label className="fw-bold">
                Start Time <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <DatePicker
                  selected={startTime}
                  onChange={handleStartTimeChange}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  dateFormat="hh:mm aa"
                  className={`form-control ${errors.startTime ? "is-invalid" : ""}`}
                  placeholderText="Select start time"
                />
                <span className="input-group-text">
                  <FaClock />
                </span>
              </div>
              {errors.startTime && (
                <div className="text-danger mt-1">{errors.startTime}</div>
              )}
            </div>
          </div>

          {/* End Time */}
          <div className="col-md-3">
            <div className="mb-3">
              <label className="fw-bold">End Time</label>
              <div className="input-group">
                <DatePicker
                  selected={endTime}
                  onChange={setEndTime}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  dateFormat="hh:mm aa"
                  className="form-control"
                  placeholderText="Select end time"
                />
                <span className="input-group-text">
                  <FaClock />
                </span>
              </div>
            </div>
          </div>

          {/* Save Button */}
          <div className="col-md-6 pt-3 pb-2">
            <button
              className="btn btn-outline-primary"
              onClick={validateAndSave}
              disabled={errors.startDate || errors.startTime}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateTime;